// extracted by mini-css-extract-plugin
export default {"RevisionCell":"RevisionCell_RevisionCell__WV0VC","Content":"RevisionCell_Content__dQrml","Name":"RevisionCell_Name__PMB9P","MultiRow":"RevisionCell_MultiRow__mXSEl"};